import Cookies from 'universal-cookie';

export function getEmptyHubErrors(badBatteryThreshold){

    // default badBatteryThreshold
    if(!badBatteryThreshold){
        badBatteryThreshold=40;
    }

    return {
        badBraceletCount:0,
        badToddleCount:0,
        badTrackerCount:0,
        badLifeguardTagCount:0,
        //suggestions:{},
        errorMemo:"",
        badBatteryThreshold:badBatteryThreshold
    };
}

export function getHubErrors( /*suggestionRules,*/ suggestedMajor, hubPopupData,hubPopupDataNote){

    // get defaults from cookies
    const cookies = new Cookies();
    let badBatteryThreshold=cookies.get('BadBatteryThreshold');
    let result=getEmptyHubErrors(badBatteryThreshold);

    try{
        // check host name
        if( hubPopupDataNote.json.sshdata.data.indexOf(hubPopupData.hostname)<0){
            result.errorMemo += `Host Name ${hubPopupData.hostname} not found in ssh data\n`;
        }

        // check each type of wearable
        result.badBraceletCount=getWearableErrorCount( result.badBatteryThreshold, hubPopupDataNote.json.bracelets);
        if(hubPopupDataNote.json.toddles){
            result.badToddleCount=getWearableErrorCount( result.badBatteryThreshold, hubPopupDataNote.json.toddles);
        } else {
            result.badToddleCount=getWearableErrorCount( result.badBatteryThreshold, hubPopupDataNote.json.buddy);
        }
        result.badTrackerCount=getWearableErrorCount( result.badBatteryThreshold, hubPopupDataNote.json.headsets);
        result.badLifeguardTagCount=getWearableErrorCount( result.badBatteryThreshold, hubPopupDataNote.json.lifeguardTags);
        result.errorMemo += getWearableErrors( result.badBatteryThreshold, 'headsets',hubPopupDataNote.json.headsets, suggestedMajor, result.badTrackerCount );
        result.errorMemo += getWearableErrors( result.badBatteryThreshold, 'buddy tags',hubPopupDataNote.json.toddles, suggestedMajor, result.badToddleCount );
        result.errorMemo += getWearableErrors( result.badBatteryThreshold, 'staff bracelets',hubPopupDataNote.json.bracelets, suggestedMajor, result.badBraceletCount );
        
        // suggested values
        //result.suggestions = [];
        //result.suggestions = getSuggestions(suggestionRules,hubPopupDataNote);


    } catch (e){
        result.errorMemo+=e.message;
    }
    return result;
}

//  getWearableErrors( thisApp, label, array, major, badCount)
function getWearableErrors( badBatteryThreshold, label, array, major, badCount){
    let badMajors=[];
    if (array){
        array.forEach(wear=>{
            let beacon=wear.beacon;
            if(!beacon){
                beacon=wear.left_beacon;
            }
            if(beacon.major!==major){
                if(badMajors.indexOf(beacon.major)<0){
                    badMajors.push(beacon.major);
                }
            }
        })
    }
    let result="";
    if(badMajors.length>0){
        result+= `The current clients major is ${major} but there are ${label} with majors set to ${badMajors}\n`;
    } else {
        result+= "";
    }
    if(badCount>0){
        result+=`There are ${badCount} ${label}(s) with battery levels at or below ${badBatteryThreshold}\n`;
    } 
    return result;
}

// getWearableErrorCount( badBatteryThreshold, array)
function getWearableErrorCount( badBatteryThreshold, array){
    let badCount=0;
    if(array){
        array.forEach(wear=>{

    /*        if(wear.beacon && wear.beacon.battery < badBatteryThreshold){
                badCount++;
            } else if(wear.left_beacon && wear.left_beacon.battery < badBatteryThreshold){
                badCount++;
            } else if(wear.right_beacon && wear.right_beacon.battery < badBatteryThreshold){
                badCount++;
            }*/
            if(wear.low_battery){
                badCount++;
            }
        })
    }
    return badCount;
}
/*
// getSuggestions(suggestionRules, hubPopupDataNote)
function getSuggestions(suggestionRules, hubPopupDataNote){

    let hubPopupSuggestions={};
    try {
            suggestionRules.forEach( rule=>{
            findValues( 
                hubPopupDataNote.json.sshdata.data,
                hubPopupSuggestions,
                rule);            
        })
    } catch (e){
        alert("Unable to run rules");
    }
    return hubPopupSuggestions;

}

// findValues( data, hubPopupSuggestions, searchObj )
// find suggextion for one field based on data in json
function findValues( data, hubPopupSuggestions, searchObj ){
    console.log(`findValues:${JSON.stringify(searchObj,null,2)}`);
    let lines=data.split("\n");
    let lineNo=0;
    let foundValue="";
    let topDisplayLine=0;
    let acceptableValues=undefined;

    try {
        // if there is a default value use it
        if(searchObj.defaultValue){
            foundValue=searchObj.defaultValue;

        // if there is a list of acceptable values use them
        } else if (searchObj.acceptableValues) {
            acceptableValues=searchObj.acceptableValues;

        // if search into json
        } else if (searchObj.findLinesWith) {

            // copy findLinesWith and search and replace values from prior finds
            let findLinesWith = searchObj.findLinesWith.map((x) => x);
            for (let findLineNumber=0;findLineNumber<findLinesWith.length;findLineNumber++){
                let findLine= findLinesWith[findLineNumber];
                for ( const replaceName in hubPopupSuggestions ){
                    if(hubPopupSuggestions[replaceName].foundValue){
                        if( findLine.indexOf("<"+replaceName+">")>-1){
                            findLinesWith[findLineNumber] = replaceAll( findLine
                                                                        ,"<"+replaceName+">"
                                                                        ,hubPopupSuggestions[replaceName].foundValue
                                                                        );
                        }
                    }
                }
            }

            // search for line
            // loop thru each findLinesWith string in array and advance lineNo till you have found each string
            findLinesWith.forEach(searchString =>{
                while( lineNo<lines.length && lines[lineNo].indexOf(searchString)<0 ){
                    lineNo++;
                }
                console.log("found line:"+lines[lineNo]);
            });

            // if you dont find the strings exit
            if(lineNo>=lines.length){
                return;
            }

            // update variable for top disply line
            topDisplayLine=lineNo;

            // skip lines
            if(searchObj.skipLines){
                lineNo=lineNo+searchObj.skipLines;
            }

            // normalize the line you are working with and split into array
            let fullLine=lines[lineNo];
            let line=fullLine.trim();
            while(line.indexOf("  ")>-1){
                line=replaceAll(line,"  "," ");
            }
            let words=line.split(" ");

            // find word number
            if(searchObj.wordNumber){
                foundValue=words[searchObj.wordNumber-1];
            }

            // wordAfter
            if(searchObj.wordAfter){
                foundValue=words[words.indexOf(searchObj.wordAfter)+1];
            }

            // everythingAfter
            if(searchObj.everythingAfter){
                foundValue=fullLine.substring( fullLine.indexOf(searchObj.everythingAfter)
                                            +searchObj.everythingAfter.length 
                                        );
                foundValue=foundValue.trim();
            }
            // everythingBefore
            if(searchObj.everythingBefore){
                foundValue=foundValue.substring( 0, foundValue.indexOf(searchObj.everythingBefore));
            }

            //removeSuroundingQuotes
            if(searchObj.removeSuroundingQuotes){
                if(foundValue[0]==='"'){
                    foundValue=foundValue.substring(1);
                }
                if(foundValue[0]==='"'){
                    foundValue=foundValue.substring(1);
                }
                if(foundValue[foundValue.length-1]==='"'){
                    foundValue=foundValue.substring(0,foundValue.length-1);
                }                    
                if(foundValue[foundValue.length-1]==='"'){
                    foundValue=foundValue.substring(0,foundValue.length-1);
                }                    
            }
        }

        // if you found something add to hubPopupSuggestions array
        if(foundValue || acceptableValues){
            let foundObject={
                foundValue:foundValue
                ,foundLine:lineNo
                ,foundAt:lines[lineNo].indexOf(foundValue)
                ,foundLength:foundValue.length
                ,topDisplayLine:topDisplayLine
                ,acceptableValues:acceptableValues
            }
            hubPopupSuggestions[searchObj.columnName]=foundObject;
        }
    } catch(e){
        console.log(e);
    }

}
//{findLinesWith:["******","== ip a ===","wlan0:"], skipLines:1, parsePosition:1 })

function replaceAll(string, search, replace) {
    return string.split(search).join(replace);
}
*/